module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("1TY4n"))).then(() => parcelRequire('2GTGK'));